// extracted by mini-css-extract-plugin
module.exports = {"Host":"Solution_Host_jwQjx","Word":"Solution_Word_3VsRX","WordText":"Solution_WordText_3o3mH","Length":"Solution_Length_sH-tQ","Definition":"Solution_Definition_2ARnp"};